import { render, staticRenderFns } from "./bookStatistics.vue?vue&type=template&id=32fcf611&scoped=true"
import script from "./bookStatistics.vue?vue&type=script&lang=js"
export * from "./bookStatistics.vue?vue&type=script&lang=js"
import style0 from "./bookStatistics.vue?vue&type=style&index=0&id=32fcf611&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcf611",
  null
  
)

export default component.exports